module.exports = __webpack_public_path__ + "img/biaoqian_keyunchezhan.35ea83ea.png";